// Shared formatting helpers for the settlement pages (PayForLesson +
// MyPayments). Single source of truth so number / date formatting and the
// Polish plural rules stay identical across both flows.

// Polish plural helper (1 / 2-4 / 5+ forms).
export const plural = (n, one, few, many) => {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (n === 1) return one;
  if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return few;
  return many;
};

export const formatLessonStart = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const date = d.toLocaleDateString("pl-PL", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  const time = d.toLocaleTimeString("pl-PL", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${date}, ${time}`;
};

export const formatDate = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("pl-PL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export const formatPln = (amount) =>
  Number(amount || 0).toLocaleString("pl-PL", {
    style: "currency",
    currency: "PLN",
  });
